var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2562 1.50012L11.1016 6.81399L12.4246 3.67888L18.2562 1.50012Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.73438 1.50012L8.83152 6.86433L7.57316 3.67888L1.73438 1.50012Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6868 13.8195L13.7812 16.7389L17.8583 17.8606L19.0304 13.8842L15.6868 13.8195Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.984375 13.8842L2.14926 17.8606L6.22634 16.7389L4.32083 13.8195L0.984375 13.8842Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99549 8.88547L4.85938 10.604L8.9077 10.7838L8.76388 6.43347L5.99549 8.88547Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9994 8.8821L11.195 6.37976L11.1016 10.7804L15.1427 10.6007L13.9994 8.8821Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21875 16.735L8.64918 15.5485L6.54952 13.9091L6.21875 16.735Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 15.5485L13.7736 16.735L13.4356 13.9091L11.3359 15.5485Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7814 16.7428L11.3438 15.5564L11.5379 17.1455L11.5163 17.8143L13.7814 16.7428Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 16.7428L8.49942 17.8143L8.48504 17.1455L8.66481 15.5564L6.23438 16.7428Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52776 12.8597L6.5 12.2629L7.93093 11.6085L8.52776 12.8597Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4688 12.8597L12.0656 11.6085L13.5037 12.2629L11.4688 12.8597Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22583 16.7386L6.57098 13.8192L4.32031 13.8839L6.22583 16.7386Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 13.8192L13.7827 16.7386L15.6882 13.8839L13.4375 13.8192Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1349 10.6051L11.0938 10.7849L11.4677 12.863L12.0645 11.6118L13.5026 12.2661L15.1349 10.6051Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49884 12.2661L7.93696 11.6118L8.52659 12.863L8.9077 10.7849L4.85938 10.6051L6.49884 12.2661Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86719 10.6051L6.56418 13.9128L6.50665 12.2661L4.86719 10.6051Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5172 12.2661L13.4453 13.9128L15.1495 10.6051L13.5172 12.2661Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92017 10.7842L8.53906 12.8623L9.01364 15.3143L9.1215 12.0857L8.92017 10.7842Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1082 10.7842L10.9141 12.0785L11.0004 15.3143L11.4821 12.8623L11.1082 10.7842Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4818 12.8588L11 15.3108L11.3451 15.5481L13.4448 13.9086L13.5167 12.262L11.4818 12.8588Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.262L6.55753 13.9086L8.65719 15.5481L9.00234 15.3108L8.52776 12.8588L6.5 12.262Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5117 17.8096L11.5332 17.1408L11.3535 16.9826H8.64261L8.47723 17.1408L8.49161 17.8096L6.22656 16.7382L7.01753 17.3853L8.62104 18.4999H11.3751L12.9858 17.3853L13.7767 16.7382L11.5117 17.8096Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3462 15.5522L11.0011 15.3149H9.00929L8.66414 15.5522L8.48438 17.1414L8.64976 16.9832H11.3606L11.5404 17.1414L11.3462 15.5522Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5553 7.15914L19.1665 4.22537L18.2533 1.50012L11.3359 6.63423L13.9965 8.88489L17.7572 9.98506L18.5913 9.01433L18.2317 8.75546L18.807 8.23055L18.3612 7.8854L18.9364 7.44677L18.5553 7.15914Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.835938 4.22537L1.44714 7.15914L1.05885 7.44677L1.6341 7.8854L1.19547 8.23055L1.77072 8.75546L1.41119 9.01433L2.23811 9.98506L5.99881 8.88489L8.65934 6.63423L1.74196 1.50012L0.835938 4.22537Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7669 9.98688L14.0062 8.88672L15.1495 10.6053L13.4453 13.913L15.6888 13.8842H19.0324L17.7669 9.98688Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99624 8.88672L2.23554 9.98688L0.984375 13.8842H4.32083L6.55711 13.913L4.86012 10.6053L5.99624 8.88672Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1015 10.7802L11.3388 6.63125L12.4318 3.6759H7.57812L8.65672 6.63125L8.90839 10.7802L8.99468 12.0889L9.00187 15.3103H10.9937L11.0081 12.0889L11.1015 10.7802Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0705882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.160f08269fba3de352e0ec23670ea592.svg";
export { ForwardRef as ReactComponent };